module.exports = __webpack_public_path__ + "static/media/StepCam.e9de5da7.mp4";